// src/Components/NotFoundPage.js

import React from "react";
import { Link } from "react-router-dom";

const NotFoundPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-gray-700">
      <h1 className="text-4xl lg:text-6xl font-bold mb-4 text-[#0A827D]">
        404
      </h1>
      <p className="text-xl lg:text-2xl h-96 mb-8">Page Not Found</p>
      <Link to="/">
        <button className="bg-[#0A827D] hover:bg-[#05736e] text-white font-bold py-3 px-5 shadow-lg transition-transform duration-300 hover:scale-110">
          Retour à la page d'accueil
        </button>
      </Link>
    </div>
  );
};

export default NotFoundPage;
